<template>
  <div>
    <Top></Top>
    <!-- top content start -->
    <div class="content bgImgCss">
      <img :src="bgImg" alt class="imgSrcCss">
      <div class="contentPosition">
        <div class="contentTop">成功案例</div>
        <div class="contentBottom">
          <div>全行业覆盖, 标杆品牌认证</div>
          <!-- <div>在这里你也成为你梦想的样子</div> -->
        </div>
      </div>

      <!-- start -->
      <div>
        <div class="imgListBox">
          <div
            class="imgBox"
            v-for=" (value,index) in listImg"
            :class="{ 'imgBoxTwo': index == listImg.length-1, 'ClassActive' : classCur == index }"
            @click="removeActive(index)"
          >
            <img v-lazy="value.url" alt>
            <div class="hoverText">{{value.text}}</div>
          </div>
        </div>
      </div>
      <!-- end -->
    </div>
    <!-- top content end -->
    <AllCase v-show="filterIndex == 0"></AllCase>
    <!-- <Retail v-show="filterIndex == 1"></Retail> -->
    <SmartCase v-show="filterIndex == 1"></SmartCase>
    <Food v-show="filterIndex == 2"></Food>
    <Cinemas v-show="filterIndex == 3"></Cinemas>
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
// 典型案例
import AllCase from "@/view/caseSearch/allCase.vue";
// 新餐饮
import Food from "@/view/caseSearch/food.vue";
// 新零售
import Retail from "@/view/caseSearch/retail.vue";
// 智慧门店
import SmartCase from "@/view/caseSearch/smartCase.vue";
// 新院线
import Cinemas from "@/view/caseSearch/cinemas.vue";

import bgImg from "@/assets/images/successAnLi.png";
import contentLeftImg1 from "@/assets/images/contentLeftImg1.png";
import contentRightImg1 from "@/assets/images/contentRightImg1.png";
import contentLeftImg2 from "@/assets/images/contentLeftImg2.png";
import contentRightImg2 from "@/assets/images/contentRightImg2.png";
import contentLeftImg3 from "@/assets/images/contentLeftImg3.png";
import contentLeftImg4 from "@/assets/images/contentLeftImg4.png";
import contentLeftImg5 from "@/assets/images/contentLeftImg5.png";
import contentLeftImg6 from "@/assets/images/contentLeftImg6.png";
import contentLeftImg7 from "@/assets/images/contentLeftImg7.png";
import contentRightImg3 from "@/assets/images/contentRightImg3.png";
import contentRightImg4 from "@/assets/images/contentRightImg4.png";
import contentRightImg5 from "@/assets/images/contentRightImg5.png";
import contentRightImg6 from "@/assets/images/contentRightImg6.png";

import positionTop1 from "@/assets/images/positionTop1.png";
import positionTop2 from "@/assets/images/positionTop2.png";
import positionTop3 from "@/assets/images/positionTop3.png";
import positionTop4 from "@/assets/images/positionTop4.png";
import positionTop5 from "@/assets/images/positionTop5.png";
import positionTop6 from "@/assets/images/positionTop6.png";
import positionTop7 from "@/assets/images/positionTop7.png";
import positionTop8 from "@/assets/images/positionTop8.png";
import positionTop9 from "@/assets/images/positionTop9.png";
import positionTop10 from "@/assets/images/positionTop10.png";
import positionTop11 from "@/assets/images/positionTop11.png";
import positionTop12 from "@/assets/images/positionTop12.png";
import positionTopLine from "@/assets/images/positionTopLine.png";

import anLiIconHoverDe from "@/assets/images/anLiIconHover1.png";
import Bread from "@/components/bread.vue";
import { constants } from "os";

export default {
  name: "SuccessCases",
  components: {
    Top,
    Footer,
    Bread,
    AllCase,
    Food,
    Retail,
    SmartCase,
    Cinemas
  },
  data() {
    return {
      toBreadChild: ["案例"],
      classCur: 0,
      filterIndex: 0,
      anLiIconHoverDe: anLiIconHoverDe,
      mask1Bol: false,
      mask2Bol: false,
      mask3Bol: false,
      mask4Bol: false,
      mask5Bol: false,
      mask6Bol: false,
      mask7Bol: false,
      bgImg: bgImg,
      contentRightImg1: contentRightImg1,
      contentLeftImg1: contentLeftImg1,
      contentLeftImg2: contentLeftImg2,
      contentRightImg2: contentRightImg2,
      contentLeftImg3: contentLeftImg3,
      contentLeftImg4: contentLeftImg4,
      contentLeftImg5: contentLeftImg5,
      contentLeftImg6: contentLeftImg6,
      contentLeftImg7: contentLeftImg7,
      contentRightImg3: contentRightImg3,
      contentRightImg4: contentRightImg4,
      contentRightImg5: contentRightImg5,
      contentRightImg6: contentRightImg6,

      positionTop1: positionTop1,
      positionTop2: positionTop2,
      positionTop3: positionTop3,
      positionTop4: positionTop4,
      positionTop5: positionTop5,
      positionTop6: positionTop6,
      positionTop7: positionTop7,
      positionTop8: positionTop8,
      positionTop9: positionTop9,
      positionTop10: positionTop10,
      positionTop11: positionTop11,
      positionTop12: positionTop12,
      positionTopLine: positionTopLine,
      textArray: ["新餐饮", "新零售", "智慧展厅", "新院线"],
      listImg: [
        {
          url: require("@/assets/images/anLiIcon1.png"),
          text: "典型案例"
        },
        // {
        //   url: require("@/assets/images/anLiIcon2.png"),
        //   text: "新零售"
        // },
        {
          url: require("@/assets/images/anLiIcon3.png"),
          text: "新零售"
        },
        {
          url: require("@/assets/images/anLiIcon4.png"),
          text: "新餐饮"
        },
        {
          url: require("@/assets/images/anLiIcon5.png"),
          text: "新院线"
        }
      ],

      listImg1: [
        {
          url: require("@/assets/images/anLiIconHover1.png"),
          text: "典型案例"
        },
        // {
        //   url: require("@/assets/images/anLiIconHover2.png"),
        //   text: "新零售"
        // },
        {
          url: require("@/assets/images/anLiIconHover3.png"),
          text: "新零售"
        },
        {
          url: require("@/assets/images/anLiIconHover4.png"),
          text: "新餐饮"
        },
        {
          url: require("@/assets/images/anLiIconHover5.png"),
          text: "新院线"
        }
      ]
    };
  },
  mounted() {
    this.changeActive(0);
  },
  methods: {
    changeActive(index) {
      console.log(index)
      this.listImg[index] = this.listImg1[index];
      this.listImg.splice(index, 1, this.listImg1[index]);
      this.classCur = index;
    },
    removeActive(index) {
      this.listImg = [
        {
          url: require("@/assets/images/anLiIcon1.png"),
          text: "典型案例"
        },
        // {
        //   url: require("@/assets/images/anLiIcon2.png"),
        //   text: "新零售"
        // },
        {
          url: require("@/assets/images/anLiIcon3.png"),
          text: "新零售"
        },
        {
          url: require("@/assets/images/anLiIcon4.png"),
          text: "新餐饮"
        },
        {
          url: require("@/assets/images/anLiIcon5.png"),
          text: "新院线"
        }
      ];
      this.filterIndex = index;
      console.log("filterIndex", this.filterIndex);
      this.changeActive(index);
    },
    toPage(val) {
      // this.$router.push(val);
      // let routeUrl = this.$router.resolve({
      //   path: `${val}`
      // });
      // window.open(routeUrl.href, "_blank");
    },
    toDetailPage(index) {},
    toShowMask1() {
      this.mask1Bol = true;
      console.log(this.mask1Bol);
      console.log(123);
    },
    toHiddleMask1() {
      this.mask1Bol = false;
      console.log(456);
    },
    toShowMask2() {
      this.mask2Bol = true;
    },
    toHiddleMask2() {
      this.mask2Bol = false;
    },
    toShowMask3() {
      this.mask3Bol = true;
    },
    toHiddleMask3() {
      this.mask3Bol = false;
    },
    toShowMask4() {
      this.mask4Bol = true;
    },
    toHiddleMask4() {
      this.mask4Bol = false;
    },
    toShowMask5() {
      this.mask5Bol = true;
    },
    toHiddleMask5() {
      this.mask5Bol = false;
    },
    toShowMask6() {
      this.mask6Bol = true;
    },
    toHiddleMask6() {
      this.mask6Bol = false;
    },
    toShowMask7() {
      this.mask7Bol = true;
    },
    toHiddleMask7() {
      this.mask7Bol = false;
    }
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 660px;
  height: 143px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 20px;
}

.contentBottom {
  width: 660px;
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* imgListBox start */
.imgListBox {
  display: flex;
  width: 75%;
  /* max-width: 1200px; */
  margin: auto;
  flex-wrap: wrap;
  margin-top: 39px;
  padding: 30px 0;
  position: absolute; 
  bottom: -125px;
  left: 12.5%;
  background: #fff;
  box-shadow: 0px 3px 27px 0px rgba(0, 0, 0, 0.1);
}

.imgBox {
  flex-grow: 1;
  margin-top: 20px;
  font-size: 2.4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 34px;
  text-align: center;
  border-right: 1px solid rgba(236, 235, 235, 1);
  padding: 10px 0;
  cursor: pointer;

}

.imgBox img {
}

.imgBoxTwo {
  border-right: 0px;
}
.hoverText {
  /* transition: 0.5s; */
}
.imgBox:hover .hoverText {
  /* color: rgba(252, 200, 0, 1); */
}

/* imgListBox end */
.contentCox::after {
  content: "";
  display: block;
  clear: both;
}

.contentCox {
  width: 70%;
  max-width: 1100px;
  margin: auto;
  margin-top: 30px;
}

.oneImgCss {
  width: 98%;
  /* max-width: 578px; */
}

.contentCox img:first-child {
}

.contentLeft {
  width: 50%;
  float: left;
  margin-bottom: 20px;
  /* opacity:0.8; */
  /* background:rgba(0,0,0,1); */
}

.contentRight {
  width: 50%;
  float: left;
  text-align: right;
  margin-bottom: 20px;
}

.contentRight,
.contentLeft {
  position: relative;
  font-size: 0;
}

.textBoxCss {
  width: 194px;
  height: 32px;
  font-size: 3.2rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
}

.positionText {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 10;
}

.mask {
  width: 98%;
  /* max-width: 578px; */
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 5;
  transition: 0.5s;
}

.maskRight {
  right: 0;
}

.oneBoxPosition {
  width: 80%;
  height: 33%;
  text-align: center;
}
.oneBoxPosition img {
  width: 70%;
  max-width: 300px;
}
.textP {
  position: absolute;
  bottom: -30px;
  width: 100%;
  font-size: 1.9rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  opacity: 0;
}

.positionTop1 {
  /* margin-bottom: 29px; */
  opacity: 0;
}

.positionRight {
  position: absolute;
  width: 39%;
  height: 40px;
  right: -5px;
  bottom: 46px;
  text-align: left;
  z-index: 10;
  opacity: 1;
}
.positionRight img {
  width: 100%;
}
.positionLeft {
  position: absolute;
  width: 39%;
  height: 40px;
  left: -5px;
  bottom: 46px;
  text-align: right;
  z-index: 10;
}
.positionLeft img {
  width: 100%;
}

.positionRightText {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}
.positionLeft {
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.breadMarginTop {
  margin-top: 170px;
}
.contentLeft:hover .mask {
  opacity: 0.8;
}
.contentLeft:hover .textP {
  opacity: 1;
}
.contentLeft:hover .positionTop1 {
  opacity: 1;
}
.contentLeft:hover .positionLeft {
  opacity: 0;
}
/* right hover */
.contentRight:hover .positionRight {
  opacity: 0;
}
.contentRight:hover .positionRight {
  opacity: 0;
}
.contentRight:hover .textP {
  opacity: 1;
}
.contentRight:hover .mask {
  opacity: 0.8;
}
.positionTop2 {
  opacity: 0;
}

.contentRight:hover .positionTop2 {
  opacity: 1;
}
.ClassActive {
  color: rgba(252, 200, 0, 1);
}
</style>



// WEBPACK FOOTER //
// src/view/SuccessCases.vue